import React, { useState, useEffect } from "react";
import TextType from './TextType';

export default function TextMove() {
  const [typingFinished, setTypingFinished] = useState(false);
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [hideCursor, setHideCursor] = useState(false);
  const textParts = ["Every small ", "push", " counts"]; 
  const textColors = ["#000000ff", "rgb(14, 90, 140)", "#000000ff"];

  const handleTypingComplete = () => {
    if (currentTextIndex < textParts.length - 1) {
      setCurrentTextIndex(prev => prev + 1);
    } else {
      setHideCursor(true); // Hide cursor immediately
      setTimeout(() => {
        setTypingFinished(true);
      }, 200); // 0.2-second pause after all typing finishes
    }
  };

  return (
    <div style={styles.body}>
      {!typingFinished ? (
        <div style={styles.typingContainer}>
          {textParts.map((part, index) => 
            index <= currentTextIndex && (
              <TextType 
                key={index}
                text={part}
                typingSpeed={60}
                variableSpeed={{ min: 70, max: 130 }}
                loop={false}
                onSentenceComplete={index === currentTextIndex ? handleTypingComplete : () => {}}
                showCursor={index === currentTextIndex && !hideCursor}
                cursorCharacter="|"
                textColors={[textColors[index]]}
              />
            )
          )}
        </div>
      ) : (
        <div style={styles.card}>
          <div style={styles.loader}>
            <span style={styles.fixed}>Every small</span>
            <div style={styles.words}>
              <span style={styles.word}> push </span>
              <span style={styles.word}> idea </span>
              <span style={styles.word}> goal </span>
              <span style={styles.word}> step </span>
              <span style={styles.word}> push </span>
              <span style={styles.word}> idea </span>
              <span style={styles.word}> step </span>
            </div>
            <span style={styles.fixed}>counts</span>
          </div>
        </div>
      )}

      <style>
        {`
        @keyframes spin_text {
          0%, 8% { transform: translateY(0%); }
          14%, 22% { transform: translateY(-100%); }
          28%, 36% { transform: translateY(-200%); }
          42%, 50% { transform: translateY(-300%); }
          56%, 64% { transform: translateY(-400%); }
          70%, 78% { transform: translateY(-500%); }
          84%, 100% { transform: translateY(-600%); }
        }
      `}
      </style>
    </div>
  );
}

const styles = {
  body: {
    marginTop: "18px",
    paddingLeft: 0,
    height: "60px",
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: '"Segoe UI", Arial, sans-serif',
  },
  typingContainer: {
    display: 'flex',
    gap: '0',
    fontWeight: 500,
    fontSize: "clamp(18px, 4vw, 28px)",
    color: "#000000ff",
    alignItems: "center",
    justifyContent: "center",
    textAlign: 'center',
    width: '90%',
    maxWidth: '400px',
    margin: '0 auto',
    height: "40px",
    padding: '0 10px',
  },
  card: {
    borderRadius: "1.25rem",
  },
  loader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0",
    fontWeight: 500,
    fontSize: "clamp(18px, 4vw, 28px)",
    width: '90%',
    maxWidth: '400px',
    margin: '0 auto',
    height: "40px",
    padding: '0 10px',
    flexWrap: 'nowrap',
  },
  fixed: {
    color: "#000000ff",
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
  words: {
    overflow: "hidden",
    position: "relative",
    height: "40px",
    lineHeight: "40px",
    flexShrink: 0,
    minWidth: 'fit-content',
    whiteSpace: 'pre',
  },
  word: {
    display: "block",
    height: "40px",
    color: "rgb(14, 90, 140)",
    animation: "spin_text 7s 1 forwards ease-in-out",
    animationDelay: "0.2s",
    whiteSpace: 'pre',
  },
};